module.exports = __webpack_public_path__ + "3e92fd2b61b8d4b4c3ea24946e20447a.png";